import { Children, cloneElement, useContext } from 'react';

import { useAgenciesGetQuery } from '../../Common/Queries/agenciesQueries';
import { useApplicationsGetQuery } from '../../Common/Queries/applicationsQueries';
import { useDepartmentGetQuery } from '../../Common/Queries/departmentQueries';
import { useFiltersGetQuery } from '../../Common/Queries/filterQueries';
import { useLevelsGetQuery } from '../../Common/Queries/levelQueries';
import { usePositionsGetQuery } from '../../Common/Queries/positionsQueries';
import { useSkillsGetQuery } from '../../Common/Queries/skillQueries';
import { useStreamGetQuery } from '../../Common/Queries/streamQueries';
import { useUsersGetQuery } from '../../Common/Queries/usersQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, AuthContext, DURATION_TIME, ROLES } from '../../constants';

export function GetApplicationOverviewContainer({ children, ...props }) {
  const { userInfo } = useContext(AuthContext);
  const role = userInfo?.roles?.[0];

  // Applications
  const applicationData = useApplicationsGetQuery({ limit: 0 });

  // Positions
  const positionList = usePositionsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Streams
  const streamList = useStreamGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Skills
  const skillList = useSkillsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Levels
  const levelList = useLevelsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // Departments
  const departmentList = useDepartmentGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Recruiters / Users
  const recruiterList = useUsersGetQuery(
    {
      limit: ALL_DATA_LIMIT,
      role: [
        ROLES.ADMIN,
        ROLES.HR,
        ROLES.HIRING_MANAGER,
        ROLES.SUPER_ADMIN,
        ROLES.TENANT_OWNER,
      ].join(','),
    },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Agencies
  const agencyList = useAgenciesGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  // Application Status
  const statusList = useFiltersGetQuery(
    { entity: 'application', field: 'status' },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  return Children.only(
    cloneElement(children, {
      applicationData,
      positionList,
      streamList,
      skillList,
      levelList,
      departmentList,
      recruiterList,
      agencyList,
      statusList,
      ...props,
    })
  );
}
